import ApiResourceManager from '../ApiResourceManager';

export default class SubscriptionsManager extends ApiResourceManager {
  get = (params) =>
    this.request({
      method: 'GET',
      url: '/subscriptions',
      params,
    });

  create = (data) =>
    this.request({
      method: 'POST',
      url: '/subscriptions',
      data,
    });

  update = (id, data) =>
    this.request({
      method: 'PUT',
      url: `/subscriptions/${id}`,
      data,
    });

  partialUpdate = (id, data) =>
    this.request({
      method: 'PATCH',
      url: `/subscriptions/${id}`,
      data,
    });

  cancel = (id) =>
    this.request({
      method: 'POST',
      url: `/subscriptions/${id}/cancel`,
    });

  resume = (id) =>
    this.request({
      method: 'POST',
      url: `/subscriptions/${id}/resume`,
    });
}
